<template>
  <div class="c-app">
    <SideMenu
      :items="routes"
      :show="showMenu"
      @toggle-menu="handleToggleMenu"
    />
    <CWrapper>
      <Header @toggle-menu="handleToggleMenu" />
      <div class="c-body">
        <CAlert
          v-if="homolog"
          color="warning"
          class="text-center mb-0"
        >
          <CIcon
            name="cil-warning"
            class="ml-2 mb-1"
          />
          <b>Você está utilizando o ambiente de homologação, quaisquer
            alterações realizadas não afetarão o sistema em produção.</b>
        </CAlert>
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
    </CWrapper>
  </div>
</template>

<script>
import SideMenu from '@/components/ui/SideMenu'
import menuItems from '@/components/ui/SideMenu/menuItems'
import Header from '@/components/layout/Header'

import SettingService from '@/services/settings.service'

export default {
  components: {
    SideMenu,
    Header
  },

  data() {
    return {
      routes: [],
      showMenu: false,
      homolog: ''
    }
  },

  created() {
    this.setRoutes()
    this.listenEventsOnRouteUpdate()
    this.openMenu()
    this.getSettings()
  },

  methods: {
    async setRoutes() {
      this.routes = menuItems.map((item) => {
        item._children = item._children.map((children) => {
          return children
        })

        return item
      })
    },

    async getSettings() {
      const data = await SettingService.listAll()
      this.homolog = data.environment === 'homolog'
    },

    listenEventsOnRouteUpdate() {
      this.$root.$on('update:routes', (data) => {
        this.setRoutes()
      })
    },

    openMenu() {
      const handler = () => {
        if (window.innerWidth > 992) {
          this.showMenu = true
        } else {
          this.showMenu = false
        }
      }

      window.addEventListener('resize', () => {
        handler()
      })

      handler()
    },

    handleToggleMenu() {
      this.showMenu = !this.showMenu
    }
  }
}
</script>
